// extracted by mini-css-extract-plugin
export default {"MessageWrap":"Message_MessageWrap__x1PYn"};